var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.breadcrumbRoutes.length && _vm.showBreadCrumb)?_c('BreadCrumb',{attrs:{"routes":_vm.breadcrumbRoutes}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }